import hexToRgba from 'hex-to-rgba'

export const SAVING = 'SAVING'
export const DEFAULT = 'DEFAULT'
export const modalStyle = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		border: 0,
		padding: 0,
		borderBottom: '6px solid #FF6D00',
	},
	overlay: {
		backgroundColor: hexToRgba('#4E4CA0', '0.9'),
		zIndex: 9,
	},
}

export const headers = {
	'Content-Type': 'application/json',
}

export const colors = {
	otpBlue: '#4E4CA0',
}
